var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('prd-toolbar'),(_vm.isLoading)?_c('prd-loader',[_c('spinner')],1):_c('prd-grid-wrapper',{attrs:{"data-items":_vm.subscriptionNodes,"columns":_vm.columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }